import { jsx as _jsx } from "react/jsx-runtime";
import { ImageElement } from "./plugins/images/ImageElement";
import { LinkElement } from "./plugins/links/LinkElement";
export const renderElement = (props) => {
    const { element, children, attributes } = props;
    // @ts-expect-error it exists on some of them, and this is fine
    const { textAlign } = element;
    const style = { textAlign };
    switch (element.type) {
        // TODO Replace with our own styled components
        case "code":
            return (_jsx("pre", { ...attributes, style, children: _jsx("code", { children: children }) }));
        case "quote":
            return (_jsx("blockquote", { ...attributes, style, children: children }));
        case "orderedList":
            return (_jsx("ol", { ...attributes, style, children: children }));
        case "list-item":
            return (_jsx("li", { ...attributes, style, children: children }));
        case "unorderedList":
            return (_jsx("ul", { ...attributes, style, children: children }));
        case "image":
            return (_jsx(ImageElement, { element: element, attributes: attributes, children: children }));
        case "headingOne":
            return (_jsx("h1", { ...attributes, style, children: children }));
        case "headingTwo":
            return (_jsx("h2", { ...attributes, style, children: children }));
        case "headingThree":
            return (_jsx("h3", { ...attributes, style, children: children }));
        case "headingFour":
            return (_jsx("h4", { ...attributes, style, children: children }));
        case "headingFive":
            return (_jsx("h5", { ...attributes, style, children: children }));
        case "headingSix":
            return (_jsx("h6", { ...attributes, style, children: children }));
        case "horizontalRule":
            return _jsx("hr", { ...attributes, style });
        case "link":
            return (_jsx(LinkElement, { element: element, attributes: attributes, style, children: children }));
        case "table":
            return (_jsx("table", { ...attributes, style, children: children }));
        case "table-head":
            return (_jsx("thead", { ...attributes, style, children: children }));
        case "table-body":
            return (_jsx("tbody", { ...attributes, style, children: children }));
        case "table-row":
            return (_jsx("tr", { ...attributes, style, children: children }));
        case "table-header-cell":
            return (_jsx("th", { ...attributes, style, children: children }));
        case "table-cell":
            return (_jsx("td", { ...attributes, style, children: children }));
        case "table-footer":
            return (_jsx("tfoot", { ...attributes, style, children: children }));
        case "paragraph":
            return (_jsx("p", { ...attributes, style, children: children }));
        default:
            return (_jsx("p", { ...attributes, style, children: children }));
    }
};
